/*
 * FileName : menuTabs.tsx
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-07-06 11:32:09
 * Description :
 * -----
 * Last Modified: 2024-07-02 15:53:08
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

// eslint-disable-next-line no-use-before-define
import React from 'react';
import { connect } from 'react-redux';
import { LangMessage } from 'src/store/common/language';
import { MenuObject, MENUTABS_DELETE, MENUTABS_DELETE_OTHERS, MENUTABS_DELETE_ALL } from 'src/store/common/menuTabs';
import { useHistory } from 'react-router-dom';
import { Tag, Dropdown, Menu } from 'antd';
import useFetchState from 'src/utils/useFetchState';
import { useLocation } from 'react-router-dom';
import bus from 'src/utils/eventBus';

type Props = {
    Mes: LangMessage;
    menuTabList: MenuObject[];
    dispatch: any;
    curMenu: string;
};

const getRouterIndex = (tabList:MenuObject[], currentRouter:MenuObject): number => {
    let routeIndex:number = 0;

    tabList.forEach((v, i) => {
        if (v.key === currentRouter.key) {
            routeIndex = i;
        }
    });
    return routeIndex;
};

const MenuTabs = (props: Props) => {
    const { menuTabList, Mes, dispatch, curMenu } = props;
    const location = useLocation();

    const [ currentRouter, setCurrentRouter ] = useFetchState<MenuObject | null>(null);
    const history = useHistory();

    const routeLink = (v: MenuObject) => {
        history.push(v.route, {
            tabsTatus: true,
        });
    };

    const closeTabs = (v: MenuObject) => {
        const routerIndex = getRouterIndex(menuTabList, v);

        dispatch({
            type: MENUTABS_DELETE,
            value: v,
        });
        routeLink(menuTabList[routerIndex - 1]);
        bus.emit('closeTab', [ v.key ]);
    };

    const mouseTabs = (v: MenuObject) => {
        if (v.key !== currentRouter?.key) {
            setCurrentRouter(v);
        }
    };

    // 关闭当前标签，回到上一层标签
    const menuClose = () => {
        if (currentRouter && !currentRouter.key.includes('Home')) {
            const routerIndex = getRouterIndex(menuTabList, currentRouter);

            dispatch({
                type: MENUTABS_DELETE,
                value: currentRouter,
            });
            if (currentRouter.route === location.pathname) {
                routeLink(menuTabList[routerIndex - 1]);
            }
            bus.emit('closeTab', [ currentRouter.key ]);
        }
    };

    const menuCloseOthers = () => {
        if (currentRouter) {
            const tablist: string[] = menuTabList.map((v) => {
                if (v.key !== currentRouter.key && !v.key.includes('Home')) {
                    return v.key;
                }
            }).filter((v) => v) as string[];

            if (currentRouter.key.includes('Home') || currentRouter.route !== location.pathname) {
                routeLink(currentRouter);
            }
            bus.emit('closeTab', tablist);
            dispatch({
                type: MENUTABS_DELETE_OTHERS,
                value: currentRouter,
            });
        }
    };

    const menuCloseAll = () => {
        const homeRoute = menuTabList.find((v) => v.key.includes('Home')) as MenuObject;

        dispatch({
            type: MENUTABS_DELETE_ALL,
            value: currentRouter,
        });
        routeLink(homeRoute);
        bus.emit('closeTab', []);
    };

    return (
        <div id='menuTabs'>
            <ul className='menu-list'>
                {menuTabList.filter((v) => v).map((v: MenuObject) =>
                    <li
                        key={v.key}
                        // className={currentRouter?.key === v.key ? 'activeMenu' : 'menuBg'}
                        onMouseEnter={() => mouseTabs(v)}
                    >
                        <Dropdown
                            overlay={
                                <Menu>
                                    <Menu.Item key='1' disabled={ v?.key?.includes('Home') } onClick={menuClose}>{ Mes['titleLabelCloseclose'] }</Menu.Item>
                                    <Menu.Item key='2' onClick={menuCloseOthers}>{ Mes['labelTitleCloseOthers'] }</Menu.Item>
                                    <Menu.Item key='3' onClick={menuCloseAll}>{ Mes['labelTitleCloseAll'] }</Menu.Item>
                                </Menu>
                            }
                            key={v.key}
                            className='point'
                            trigger={[ 'contextMenu' ]}>
                            <Tag
                                closable={ !v?.key?.includes('Home') }
                                onClose={() => closeTabs(v)}
                                key={v.key}
                                onClick={() => {
                                    routeLink(v);
                                }}
                                className={v.key === curMenu ? 'antd-active-tag' : '' }
                                onContextMenu={() => mouseTabs(v)}
                            >
                                {Mes[v.title]}
                            </Tag>
                        </Dropdown>
                    </li>
                )}
            </ul>
        </div>
    );
};

export default connect((state: any) => ({
    Mes: state.langSwitch.message,
    menuTabList: state.menuTabsDispose.menuTabs,
    curMenu: state.activeMenus.curMenu,
}))(MenuTabs);
